import { fetchJsonResponse } from '@/ai/api'
import { trackCardsGenerated } from '@/utils/helpHero'
import { buildSingleCardPrompt } from '@/ai/prompts'

export const generateSingleCard = async ({
  eventId,
  workflow,
  cardTypes,
  cardTypeId,
  abortController
}) => {
  if (!workflow || !workflow.aiVersion) {
    return null
  }

  const messages = buildSingleCardPrompt({
    eventId,
    workflow,
    cardTypes,
    cardTypeId
  })

  const response = await fetchJsonResponse({
    messages,
    aiVersion: workflow.aiVersion,
    signal: abortController?.signal
  })

  trackCardsGenerated(response)

  return response || null
}
